import { render, staticRenderFns } from "./ErrorPageIndex.vue?vue&type=template&id=1116f318&scoped=true&"
import script from "./ErrorPageIndex.vue?vue&type=script&lang=js&"
export * from "./ErrorPageIndex.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPageIndex.vue?vue&type=style&index=0&id=1116f318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116f318",
  null
  
)

export default component.exports